import type {Upgrades as RawUpgrades} from '@/api/bffOffer';
import type {Query, Upgrades} from '@/redux/v1/offerUpselling/models';

export const mapRawUpgrades = (rawUpgrades: RawUpgrades): Upgrades => ({
  roomUpgrade: (rawUpgrades.roomUpgrade || []).map((item) => ({
    attributes: item.attributes ?? [],
    boardType: item.boardType ?? [],
    roomType: item.roomType ?? [],
    description: item.description ?? [],
  })),
  tourOperatorSpecials: rawUpgrades.tourOperatorSpecials ?? [],
  transportations: rawUpgrades.transportations ?? [],
});

export const makeCacheKey = (query: Query): string => {
  return `${query.offerId}_${query.travelType}`;
};
